/***  Generated file, do not change.  */
import { MenuComponent } from './menu/menu';
import { dailyplantsummary_Desktop } from '../pages/dailyplantsummary/Desktop/dailyplantsummary';
import { desktopmenu_Desktop } from '../pages/desktopmenu/Desktop/desktopmenu';
import { trendreport_Desktop } from '../pages/trendreport/Desktop/trendreport';
export class Screens {
  static declarations = [
    MenuComponent,
    dailyplantsummary_Desktop,
    desktopmenu_Desktop,
    trendreport_Desktop
  ];
  static mapping = {
    'dailyplantsummary': {
      Desktop: dailyplantsummary_Desktop
    },
    'desktopmenu': {
      Desktop: desktopmenu_Desktop
    },
    'trendreport': {
      Desktop: trendreport_Desktop
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/app.screens.ts